import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFastForward"><Path d="M12.2323 10.6975L4.5 5V19L12.2323 13.3025M12.5 5L22 12L12.5 19V5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFastForward;
